export const TEAM_TABS = ['members', 'pending-invitations']
